import notificationsTranslations from 'projects/main/src/app/pages/notification-center/i18n/es-ES.json'
import assetsTree from '../../../../elements/assets-tree/i18n/es-ES.json'
import createOrEditPendencyDialog from '../../../../elements/create-or-edit-pendency-dialog/i18n/es-ES.json'
import fcMaintenanceSelect from '../../../../elements/fc-maintenance-select/i18n/es-ES.json'
import fcSelectMultiplePage from '../../../../elements/fc-select-multiple-paged/i18n/es-ES.json'
import fcSelectPage from '../../../../elements/fc-select-paged/i18n/es-ES.json'
import maintenanceProductsTab from '../../../../elements/maintenance-products-tab/i18n/es-ES.json'
import maintenanceServicesTab from '../../../../elements/maintenance-services-tab/i18n/es-ES.json'
import notificationsDialog from '../../../../elements/notifications-dialog/i18n/es-ES.json'
import updatePendencyAssigneeModal from '../../../../elements/update-pendency-assignee-modal/i18n/es-ES.json'
import warrantiesEquipmentTab from '../../../../elements/warranties-equipment-tab/i18n/es-ES.json'
import warrantiesMaintenanceTab from '../../../../elements/warranties-maintenance-tab/i18n/es-ES.json'
import pipes from '../../../../pipes/i18n/es-ES.json'
import confirmDialog from '../../../components/confirm-dialog/i18n/es-ES.json'
import translateMaintenanceStatus from '../../../pipes/translate-maintenance-status/i18n/es-ES.json'

export default {
  ...assetsTree,
  ...translateMaintenanceStatus,
  ...confirmDialog,
  ...createOrEditPendencyDialog,
  ...updatePendencyAssigneeModal,
  ...fcMaintenanceSelect,
  ...fcSelectMultiplePage,
  ...fcSelectPage,
  ...notificationsDialog,
  ...pipes,
  ...notificationsTranslations,
  ...maintenanceProductsTab,
  ...maintenanceServicesTab,
  ...warrantiesEquipmentTab,
  ...warrantiesMaintenanceTab
}
